<template>
    <div class="profile">
       <div class="container mt-5">
            <section class="bg white mt-sm-5 mt-3">
                <h2 class="ui header large-lg medium-md small black pt-4 pb-4 px-lg-5 px-md-3 px-2 mb-0 text-center">{{$t('Profile')}}</h2>
                <hr class="gray-7 mt-0 d-none d-sm-block">
                <div class="row pt-lg-3 pt-sm-2 pt-0 px-lg-5 px-md-3 px-2 pb-lg-5 pb-md-3 pb-2">
                    <div class="col-md-3 col-12">
                        <div class="sidebar h-100 theme d-none d-md-block">
                            <div class="sidebar__title title text-center">
                                <h3 class="ui text huge-lg big-sm large pt-2 pb-1 color white">{{$t('Menu')}}</h3>
                            </div>
                            <ul class="sidebar__list pl-xl-4 pl-0">
                                <li class="item p-lg-3 p-1 menu-color active">
                                    <router-link :to="'/profile'" exact class="ui text large-xl medium-md d-flex align-items-center "><span class="d-inline-block w-40 text-center"><i class="icon-custom-profile large"></i></span>
                                        <span>{{$t('Account')}}</span>
                                    </router-link>
                                </li>
                                <li class="item p-lg-3 p-1 menu-color">
                                    <router-link :to="'/profile/changepassword'" exact class="ui text large-xl medium-md d-flex align-items-center"><span class="d-inline-block w-40 text-center"><i class="icon-custom-reset-pass large"></i></span>
                                        <span>{{$t('ChangePassword')}}</span>
                                    </router-link>
                                </li>
                                <li class="item p-lg-3 p-1 menu-color">
                                    <router-link :to="'/profile/order'" exact class="ui text large-xl medium-md d-flex align-items-center"><span class="d-inline-block w-40 text-center"><i class="icon-custom-list large"></i></span>
                                        <span>{{$t('HistoryOrders')}}</span>
                                    </router-link>
                                </li>
                                <!-- <li class="item p-lg-3 p-1 menu-color">
                                    <router-link :to="'/profile/point'" exact class="ui text large-xl medium-md d-flex align-items-center"><span class="d-inline-block w-40 text-center"><i class="icon-custom-coin large"></i></span>
                                        <span>พอยท์แลกสินค้า</span>
                                    </router-link>
                                </li> -->
                            </ul>
                        </div>
                        <div class="ui secondary pointing menu d-flex d-md-none mb-4">
                            <a class="item active px-2 ui text mini ml-auto">{{$t('Account')}}</a> 
                            <a class="item px-2 ui text mini">{{$t('ChangePassword')}}</a> 
                            <a class="item px-2 ui text mini">{{$t('HistoryOrders')}}</a> 
                            <!-- <a class="item px-2 ui text mini mr-auto">พอยท์แลกสินค้า</a> -->
                        </div>
                    </div>
                    <div class="col">
                        <router-view :user="user" />
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>

export default {
  name: 'profile',
  components: {
   
  },
  data(){
    return {
      user: {},
      loading : true
    }
  },
  created() {
    this._getProfile()
  },
  methods:{
    _getProfile(){
        this.$http.get('profile').then(response => {
            let user = response.data.data
            this.user = user
        }).catch(error => {
                this.logged = false
                localStorage.removeItem("_auth");
                localStorage.removeItem("accountType");
                this.$parent.logout()
            })
    }
  }
}
</script>
